// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* transactions-list.component.css */

/* ── CSS Custom Properties ────────────────────────────────────────── */
/* Using :host so variables are scoped to this component in Angular   */
:host {
  display: block;
  font-family: 'DM Sans', 'Segoe UI', sans-serif;
}

/* Fallback: all variables also declared on .page-wrapper so they
   cascade correctly regardless of ViewEncapsulation mode */
.page-wrapper {
  --bg:             #f5f6fa;
  --surface:        #ffffff;
  --border:         #e8eaf0;
  --text-primary:   #1a1d2e;
  --text-secondary: #6b7280;
  --text-muted:     #9ca3af;
  --accent:         #4f46e5;
  --accent-light:   #eef2ff;

  --success:        #059669;
  --success-bg:     #d1fae5;
  --warning:        #d97706;
  --warning-bg:     #fef3c7;
  --danger:         #dc2626;
  --danger-bg:      #fee2e2;
  --pending:        #7c3aed;
  --pending-bg:     #ede9fe;

  --shadow-md:      0 4px 20px rgba(0, 0, 0, 0.08);
  --radius:         12px;
  --radius-sm:      8px;
}

/* ── Layout ───────────────────────────────────────────────────────── */
.page-wrapper {
  background: var(--bg);
  min-height: 100vh;
  padding: 32px;
}

.card {
  background: var(--surface);
  border-radius: var(--radius);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border);
  overflow: hidden;
  max-width: 1200px;
  margin: 0 auto;
}

/* ── Card Header ──────────────────────────────────────────────────── */
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border);
  flex-wrap: wrap;
  gap: 16px;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  letter-spacing: -0.3px;
  margin: 0;
}

.controls {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* ── Filter Button ────────────────────────────────────────────────── */
.filter-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--surface);
  color: var(--text-secondary);
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
}

.filter-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
  background: var(--accent-light);
}

.filter-btn .icon {
  width: 15px;
  height: 15px;
}

/* ── Selects ──────────────────────────────────────────────────────── */
.select-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.select-wrap select {
  appearance: none;
  -webkit-appearance: none;
  padding: 8px 32px 8px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--surface);
  color: var(--text-secondary);
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  min-width: 170px;
  transition: border-color 0.15s, color 0.15s, box-shadow 0.15s;
}

.select-wrap select:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.select-wrap select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);
}

.select-wrap .chevron {
  position: absolute;
  right: 10px;
  width: 14px;
  height: 14px;
  color: var(--text-muted);
  pointer-events: none;
}

/* ── Export Button ────────────────────────────────────────────────── */
.export-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 16px;
  background: var(--accent);
  color: #ffffff;
  border: none;
  border-radius: var(--radius-sm);
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, transform 0.15s, box-shadow 0.15s;
  letter-spacing: 0.1px;
}

.export-btn:hover {
  background: #4338ca;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.3);
}

.export-btn .icon {
  width: 15px;
  height: 15px;
}

/* ── Table ────────────────────────────────────────────────────────── */
.table-wrap {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead tr {
  background: #f9fafb;
}

th {
  padding: 12px 16px;
  text-align: left;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
}

td {
  padding: 13px 16px;
  font-size: 13.5px;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
}

/* ── Table Row Animation ──────────────────────────────────────────── */
.table-row {
  animation: fadeSlide 0.3s ease both;
  transition: background 0.12s;
}

.table-row:hover {
  background: #fafbff;
}

.table-row:last-child td {
  border-bottom: none;
}

@keyframes fadeSlide {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ── Transaction ID ───────────────────────────────────────────────── */
.tx-id {
  font-family: 'DM Mono', 'Courier New', monospace;
  font-size: 12.5px;
  font-weight: 500;
  color: var(--accent);
  background: var(--accent-light);
  padding: 3px 8px;
  border-radius: 5px;
  display: inline-block;
}

/* ── Collector ────────────────────────────────────────────────────── */
.collector-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.collector-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  background: linear-gradient(135deg, #c7d2fe, #a5b4fc);
  color: #4338ca;
  flex-shrink: 0;
}

.collector-name {
  font-weight: 500;
  font-size: 13.5px;
}

/* ── Ref Number ───────────────────────────────────────────────────── */
.ref-num {
  font-family: 'DM Mono', 'Courier New', monospace;
  font-size: 12.5px;
  color: var(--text-secondary);
}

/* ── Date ─────────────────────────────────────────────────────────── */
.date-cell {
  color: var(--text-secondary);
  font-size: 13px;
}

/* ── Payment Method Tags ──────────────────────────────────────────── */
.method-tags {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}

.method-tag {
  font-size: 11.5px;
  font-weight: 500;
  padding: 2px 9px;
  border-radius: 20px;
  background: #f3f4f6;
  color: var(--text-secondary);
  border: 1px solid #e5e7eb;
}

/* ── Status Badges ────────────────────────────────────────────────── */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.badge::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.badge-success {
  background: var(--success-bg);
  color: var(--success);
}
.badge-success::before {
  background: var(--success);
}

.badge-partial {
  background: var(--warning-bg);
  color: var(--warning);
}
.badge-partial::before {
  background: var(--warning);
}

.badge-failed {
  background: var(--danger-bg);
  color: var(--danger);
}
.badge-failed::before {
  background: var(--danger);
}

.badge-pending {
  background: var(--pending-bg);
  color: var(--pending);
}
.badge-pending::before {
  background: var(--pending);
}

/* ── View History Button ──────────────────────────────────────────── */
.view-btn {
  background: none;
  border: 1px solid var(--border);
  border-radius: 7px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-muted);
  transition: border-color 0.15s, color 0.15s, background 0.15s;
}

.view-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
  background: var(--accent-light);
}

.view-btn svg {
  width: 15px;
  height: 15px;
}

/* ── Empty State ──────────────────────────────────────────────────── */
.empty-state {
  text-align: center;
  padding: 48px 24px;
  color: var(--text-muted);
}

.empty-state svg {
  width: 36px;
  height: 36px;
  margin-bottom: 12px;
  color: var(--text-muted);
}

.empty-state p {
  font-size: 14px;
}

/* ── Card Footer ──────────────────────────────────────────────────── */
.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  border-top: 1px solid var(--border);
  background: #f9fafb;
  gap: 12px;
  flex-wrap: wrap;
}

.footer-info {
  font-size: 13px;
  color: var(--text-secondary);
}

/* ── Pagination ───────────────────────────────────────────────────── */
.pagination {
  display: flex;
  gap: 4px;
}

.page-btn {
  width: 32px;
  height: 32px;
  border: 1px solid var(--border);
  background: var(--surface);
  border-radius: 6px;
  font-size: 13px;
  font-family: inherit;
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.12s, color 0.12s, background 0.12s;
  font-weight: 500;
}

.page-btn:hover:not(:disabled) {
  border-color: var(--accent);
  color: var(--accent);
}

.page-btn.active {
  background: var(--accent);
  color: #ffffff;
  border-color: var(--accent);
}

.page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}




  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  body {
    font-family: 'Inter', sans-serif;
    background: #f3f4f6;
    min-height: 100vh;
  }

  /* ── Background page table ── */
  .page-table-wrap {
    width: 100%;
    overflow-x: auto;
    background: #fff;
  }

  .page-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    color: #374151;
    white-space: nowrap;
  }

  .page-table thead th {
    background: #f9fafb;
    padding: 11px 14px;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    border-bottom: 1px solid #e5e7eb;
    border-top: 1px solid #e5e7eb;
  }

  .page-table tbody td {
    padding: 11px 14px;
    border-bottom: 1px solid #f3f4f6;
    color: #6b7280;
    font-size: 13px;
  }

  .page-table tbody td.hash { color: #9ca3af; font-weight: 500; }

  .tbl-btn {
    padding: 4px 12px;
    border-radius: 5px;
    border: 1px solid #d1d5db;
    background: #fff;
    font-size: 12px;
    color: #374151;
    cursor: pointer;
    font-family: 'Inter', sans-serif;
  }

  .status-pill {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 500;
  }
  .status-success { background: #d1fae5; color: #065f46; }

  /* ── Overlay ── */
  .overlay {
    position: fixed;
    inset: 0;
    background: rgba(107, 114, 128, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    animation: fadeIn 0.15s ease;
  }

  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes slideUp {
    from { opacity: 0; transform: translateY(12px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  /* ── Modal ── */
  .modal {
    background: #fff;
    border-radius: 10px;
    width: 870px;
    max-width: 96vw;
    max-height: 90vh;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0,0,0,0.18), 0 4px 16px rgba(0,0,0,0.08);
    animation: slideUp 0.2s cubic-bezier(0.16,1,0.3,1);
    display: flex;
    flex-direction: column;
  }

  .modal-header {
    padding: 20px 24px 0;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-shrink: 0;
  }

  .modal-title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
  }

  .modal-sub {
    font-size: 12.5px;
    color: #3b82f6;
    font-weight: 500;
    margin-top: 3px;
    cursor: pointer;
  }
  .modal-sub:hover { text-decoration: underline; }

  .close-btn {
    width: 28px; height: 28px;
    border: none;
    background: transparent;
    font-size: 20px;
    color: #9ca3af;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    transition: background 0.12s;
    flex-shrink: 0;
    font-family: 'Inter', sans-serif;
  }
  .close-btn:hover { background: #f3f4f6; color: #374151; }

  /* ── Inner table ── */
  .modal-body {
    padding: 16px 24px 24px;
    overflow-x: auto;
    flex: 1;
  }

  .inner-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    white-space: nowrap;
  }

  .inner-table thead th {
    padding: 9px 14px;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    border-bottom: 1px solid #e5e7eb;
  }
  .inner-table thead th:first-child { padding-left: 2px; }

  .inner-table tbody tr:hover { background: #f9fafb; }
  .inner-table tbody tr:not(:last-child) td { border-bottom: 1px solid #f3f4f6; }

  .inner-table tbody td {
    padding: 13px 14px;
    color: #6b7280;
    font-size: 13px;
  }
  .inner-table tbody td:first-child { padding-left: 2px; }

  .td-id   { color: #9ca3af; font-size: 12.5px; }
  .td-date { color: #6b7280; font-size: 12.5px; }
  .td-amount { color: #111827; font-weight: 500; }
  .td-method { color: #374151; }
  .td-source { color: #374151; font-weight: 500; }

  /* Badges */
  .badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 500;
  }
  .badge-success { background: #ecfdf5; color: #059669; }
  .badge-failed  { background: #fef2f2; color: #dc2626; }

  /* Eye button */
  .eye-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #9ca3af;
    padding: 4px 6px;
    border-radius: 5px;
    display: inline-flex;
    align-items: center;
    transition: color 0.12s, background 0.12s;
  }
  .eye-btn:hover { color: #374151; background: #f3f4f6; }

  /* Version select */
  .version-select {
    appearance: none;
    -webkit-appearance: none;
    background: #fff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    color: #6b7280;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    padding: 6px 28px 6px 10px;
    cursor: pointer;
    outline: none;
    transition: border-color 0.12s;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2.5'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 8px center;
    min-width: 158px;
  }
  .version-select:hover, .version-select:focus { border-color: #93c5fd; }


  .modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: 100vh;
}

.modal-content {
  border-radius: 10px;
}

.modal-title{
  font-weight:600;
  font-size:18px;
}

.modal-sub{
  font-size:13px;
  color:#888;
}

.inner-table{
  width:100%;
}

.eye-btn{
  border:none;
  background:transparent;
  cursor:pointer;
}

.version-select{
  padding:4px 8px;
}


.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;

  .modal-title {
    font-size: 16px;
    font-weight: 600;
    color: #374151;
    margin: 0;
  }
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #6b7280;

  &:hover { color: #111; }
}

.modal-body {
  padding: 16px 20px;
}

.json-textarea {
  width: 100%;
  height: 320px;
  resize: vertical;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 12px;
  font-family: monospace;
  font-size: 13px;
  line-height: 1.6;
  color: #1f2937;
  outline: none;

  &:focus { border-color: #6366f1; }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;

  .submit-btn {
    padding: 8px 24px;
    background: #111827;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;

    &:hover { background: #374151; }
  }
}

.submitButton{padding: 8px;}
.filters-row {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* shared dropdown/input container */
.control-box {
  position: relative;
  height: 36px;
  min-width: 210px;
  border: 1px solid #d7dbe7;
  border-radius: 10px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 12px;
  transition: 0.2s;
}

/* hover effect */
.control-box:hover {
  border-color: #b8c0d9;
}

/* focus style */
.control-box:focus-within {
  border-color: #6c8cff;
  box-shadow: 0 0 0 2px rgba(108,140,255,0.15);
}

/* dropdown */
.control-box select {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #2d3553;
  appearance: none;
}

/* input */
.control-box input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #2d3553;
}

/* icons */
.control-box .icon {
  margin-right: 8px;
  color: #7b819c;
  font-size: 14px;
}

.control-box .arrow {
  position: absolute;
  right: 10px;
  font-size: 12px;
  color: #7b819c;
  pointer-events: none;
}
.resubmitButton{border: 1px solid gray;
    padding: 6px;}
`, "",{"version":3,"sources":["webpack://./src/app/views/logger/logger.component.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,wEAAwE;AACxE,uEAAuE;AACvE;EACE,cAAc;EACd,8CAA8C;AAChD;;AAEA;2DAC2D;AAC3D;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,gDAAgD;EAChD,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,wEAAwE;AACxE;EACE,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,+DAA+D;EAC/D,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,wEAAwE;AACxE;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wEAAwE;AACxE;EACE,gDAAgD;EAChD,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qDAAqD;EACrD,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wEAAwE;AACxE;EACE,gDAAgD;EAChD,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,wEAAwE;AACxE;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,wEAAwE;AACxE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;;;EAKE,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;EAExE;IACE,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA,gCAAgC;EAChC;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;IACd,eAAe;EACjB;;EAEA,4BAA4B,cAAc,EAAE,gBAAgB,EAAE;;EAE9D;IACE,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;EACA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;;EAEvD,kBAAkB;EAClB;IACE,eAAe;IACf,QAAQ;IACR,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;EAC9B;;EAEA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;EAC5D;IACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;EAC/C;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qEAAqE;IACrE,kDAAkD;IAClD,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;EACA,mBAAmB,0BAA0B,EAAE;;EAE/C;IACE,WAAW,EAAE,YAAY;IACzB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,4BAA4B;IAC5B,cAAc;IACd,gCAAgC;EAClC;EACA,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;;EAExD,sBAAsB;EACtB;IACE,uBAAuB;IACvB,gBAAgB;IAChB,OAAO;EACT;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;EAClC;EACA,oCAAoC,iBAAiB,EAAE;;EAEvD,8BAA8B,mBAAmB,EAAE;EACnD,4CAA4C,gCAAgC,EAAE;;EAE9E;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;EACA,oCAAoC,iBAAiB,EAAE;;EAEvD,WAAW,cAAc,EAAE,iBAAiB,EAAE;EAC9C,WAAW,cAAc,EAAE,iBAAiB,EAAE;EAC9C,aAAa,cAAc,EAAE,gBAAgB,EAAE;EAC/C,aAAa,cAAc,EAAE;EAC7B,aAAa,cAAc,EAAE,gBAAgB,EAAE;;EAE/C,WAAW;EACX;IACE,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;EACA,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;EACtD,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;;EAEtD,eAAe;EACf;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,yCAAyC;EAC3C;EACA,iBAAiB,cAAc,EAAE,mBAAmB,EAAE;;EAEtD,mBAAmB;EACnB;IACE,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,2NAA2N;IAC3N,4BAA4B;IAC5B,qCAAqC;IACrC,gBAAgB;EAClB;EACA,+CAA+C,qBAAqB,EAAE;;;EAGtE;EACA,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;;EAEhC;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;;EAEd,UAAU,WAAW,EAAE;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;;EAEb,UAAU,qBAAqB,EAAE;AACnC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;;EAE7B;IACE,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;;IAEf,UAAU,mBAAmB,EAAE;EACjC;AACF;;AAEA,cAAc,YAAY,CAAC;AAC3B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA,gBAAgB,sBAAsB;IAClC,YAAY,CAAC","sourcesContent":["/* transactions-list.component.css */\r\n\r\n/* ── CSS Custom Properties ────────────────────────────────────────── */\r\n/* Using :host so variables are scoped to this component in Angular   */\r\n:host {\r\n  display: block;\r\n  font-family: 'DM Sans', 'Segoe UI', sans-serif;\r\n}\r\n\r\n/* Fallback: all variables also declared on .page-wrapper so they\r\n   cascade correctly regardless of ViewEncapsulation mode */\r\n.page-wrapper {\r\n  --bg:             #f5f6fa;\r\n  --surface:        #ffffff;\r\n  --border:         #e8eaf0;\r\n  --text-primary:   #1a1d2e;\r\n  --text-secondary: #6b7280;\r\n  --text-muted:     #9ca3af;\r\n  --accent:         #4f46e5;\r\n  --accent-light:   #eef2ff;\r\n\r\n  --success:        #059669;\r\n  --success-bg:     #d1fae5;\r\n  --warning:        #d97706;\r\n  --warning-bg:     #fef3c7;\r\n  --danger:         #dc2626;\r\n  --danger-bg:      #fee2e2;\r\n  --pending:        #7c3aed;\r\n  --pending-bg:     #ede9fe;\r\n\r\n  --shadow-md:      0 4px 20px rgba(0, 0, 0, 0.08);\r\n  --radius:         12px;\r\n  --radius-sm:      8px;\r\n}\r\n\r\n/* ── Layout ───────────────────────────────────────────────────────── */\r\n.page-wrapper {\r\n  background: var(--bg);\r\n  min-height: 100vh;\r\n  padding: 32px;\r\n}\r\n\r\n.card {\r\n  background: var(--surface);\r\n  border-radius: var(--radius);\r\n  box-shadow: var(--shadow-md);\r\n  border: 1px solid var(--border);\r\n  overflow: hidden;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* ── Card Header ──────────────────────────────────────────────────── */\r\n.card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 20px 24px;\r\n  border-bottom: 1px solid var(--border);\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n}\r\n\r\n.card-title {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  letter-spacing: -0.3px;\r\n  margin: 0;\r\n}\r\n\r\n.controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* ── Filter Button ────────────────────────────────────────────────── */\r\n.filter-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 14px;\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-sm);\r\n  background: var(--surface);\r\n  color: var(--text-secondary);\r\n  font-family: inherit;\r\n  font-size: 13.5px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s, color 0.15s, background 0.15s;\r\n}\r\n\r\n.filter-btn:hover {\r\n  border-color: var(--accent);\r\n  color: var(--accent);\r\n  background: var(--accent-light);\r\n}\r\n\r\n.filter-btn .icon {\r\n  width: 15px;\r\n  height: 15px;\r\n}\r\n\r\n/* ── Selects ──────────────────────────────────────────────────────── */\r\n.select-wrap {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.select-wrap select {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  padding: 8px 32px 8px 12px;\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-sm);\r\n  background: var(--surface);\r\n  color: var(--text-secondary);\r\n  font-family: inherit;\r\n  font-size: 13.5px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  min-width: 170px;\r\n  transition: border-color 0.15s, color 0.15s, box-shadow 0.15s;\r\n}\r\n\r\n.select-wrap select:hover {\r\n  border-color: var(--accent);\r\n  color: var(--accent);\r\n}\r\n\r\n.select-wrap select:focus {\r\n  outline: none;\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);\r\n}\r\n\r\n.select-wrap .chevron {\r\n  position: absolute;\r\n  right: 10px;\r\n  width: 14px;\r\n  height: 14px;\r\n  color: var(--text-muted);\r\n  pointer-events: none;\r\n}\r\n\r\n/* ── Export Button ────────────────────────────────────────────────── */\r\n.export-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 8px 16px;\r\n  background: var(--accent);\r\n  color: #ffffff;\r\n  border: none;\r\n  border-radius: var(--radius-sm);\r\n  font-family: inherit;\r\n  font-size: 13.5px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s, transform 0.15s, box-shadow 0.15s;\r\n  letter-spacing: 0.1px;\r\n}\r\n\r\n.export-btn:hover {\r\n  background: #4338ca;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.3);\r\n}\r\n\r\n.export-btn .icon {\r\n  width: 15px;\r\n  height: 15px;\r\n}\r\n\r\n/* ── Table ────────────────────────────────────────────────────────── */\r\n.table-wrap {\r\n  overflow-x: auto;\r\n}\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\nthead tr {\r\n  background: #f9fafb;\r\n}\r\n\r\nth {\r\n  padding: 12px 16px;\r\n  text-align: left;\r\n  font-size: 11.5px;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.6px;\r\n  border-bottom: 1px solid var(--border);\r\n  white-space: nowrap;\r\n}\r\n\r\ntd {\r\n  padding: 13px 16px;\r\n  font-size: 13.5px;\r\n  color: var(--text-primary);\r\n  border-bottom: 1px solid var(--border);\r\n  vertical-align: middle;\r\n}\r\n\r\n/* ── Table Row Animation ──────────────────────────────────────────── */\r\n.table-row {\r\n  animation: fadeSlide 0.3s ease both;\r\n  transition: background 0.12s;\r\n}\r\n\r\n.table-row:hover {\r\n  background: #fafbff;\r\n}\r\n\r\n.table-row:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n@keyframes fadeSlide {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(6px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* ── Transaction ID ───────────────────────────────────────────────── */\r\n.tx-id {\r\n  font-family: 'DM Mono', 'Courier New', monospace;\r\n  font-size: 12.5px;\r\n  font-weight: 500;\r\n  color: var(--accent);\r\n  background: var(--accent-light);\r\n  padding: 3px 8px;\r\n  border-radius: 5px;\r\n  display: inline-block;\r\n}\r\n\r\n/* ── Collector ────────────────────────────────────────────────────── */\r\n.collector-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.collector-avatar {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  background: linear-gradient(135deg, #c7d2fe, #a5b4fc);\r\n  color: #4338ca;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.collector-name {\r\n  font-weight: 500;\r\n  font-size: 13.5px;\r\n}\r\n\r\n/* ── Ref Number ───────────────────────────────────────────────────── */\r\n.ref-num {\r\n  font-family: 'DM Mono', 'Courier New', monospace;\r\n  font-size: 12.5px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* ── Date ─────────────────────────────────────────────────────────── */\r\n.date-cell {\r\n  color: var(--text-secondary);\r\n  font-size: 13px;\r\n}\r\n\r\n/* ── Payment Method Tags ──────────────────────────────────────────── */\r\n.method-tags {\r\n  display: flex;\r\n  gap: 5px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.method-tag {\r\n  font-size: 11.5px;\r\n  font-weight: 500;\r\n  padding: 2px 9px;\r\n  border-radius: 20px;\r\n  background: #f3f4f6;\r\n  color: var(--text-secondary);\r\n  border: 1px solid #e5e7eb;\r\n}\r\n\r\n/* ── Status Badges ────────────────────────────────────────────────── */\r\n.badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 10px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.badge::before {\r\n  content: '';\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.badge-success {\r\n  background: var(--success-bg);\r\n  color: var(--success);\r\n}\r\n.badge-success::before {\r\n  background: var(--success);\r\n}\r\n\r\n.badge-partial {\r\n  background: var(--warning-bg);\r\n  color: var(--warning);\r\n}\r\n.badge-partial::before {\r\n  background: var(--warning);\r\n}\r\n\r\n.badge-failed {\r\n  background: var(--danger-bg);\r\n  color: var(--danger);\r\n}\r\n.badge-failed::before {\r\n  background: var(--danger);\r\n}\r\n\r\n.badge-pending {\r\n  background: var(--pending-bg);\r\n  color: var(--pending);\r\n}\r\n.badge-pending::before {\r\n  background: var(--pending);\r\n}\r\n\r\n/* ── View History Button ──────────────────────────────────────────── */\r\n.view-btn {\r\n  background: none;\r\n  border: 1px solid var(--border);\r\n  border-radius: 7px;\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  color: var(--text-muted);\r\n  transition: border-color 0.15s, color 0.15s, background 0.15s;\r\n}\r\n\r\n.view-btn:hover {\r\n  border-color: var(--accent);\r\n  color: var(--accent);\r\n  background: var(--accent-light);\r\n}\r\n\r\n.view-btn svg {\r\n  width: 15px;\r\n  height: 15px;\r\n}\r\n\r\n/* ── Empty State ──────────────────────────────────────────────────── */\r\n.empty-state {\r\n  text-align: center;\r\n  padding: 48px 24px;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.empty-state svg {\r\n  width: 36px;\r\n  height: 36px;\r\n  margin-bottom: 12px;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.empty-state p {\r\n  font-size: 14px;\r\n}\r\n\r\n/* ── Card Footer ──────────────────────────────────────────────────── */\r\n.card-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 14px 24px;\r\n  border-top: 1px solid var(--border);\r\n  background: #f9fafb;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.footer-info {\r\n  font-size: 13px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* ── Pagination ───────────────────────────────────────────────────── */\r\n.pagination {\r\n  display: flex;\r\n  gap: 4px;\r\n}\r\n\r\n.page-btn {\r\n  width: 32px;\r\n  height: 32px;\r\n  border: 1px solid var(--border);\r\n  background: var(--surface);\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  font-family: inherit;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: border-color 0.12s, color 0.12s, background 0.12s;\r\n  font-weight: 500;\r\n}\r\n\r\n.page-btn:hover:not(:disabled) {\r\n  border-color: var(--accent);\r\n  color: var(--accent);\r\n}\r\n\r\n.page-btn.active {\r\n  background: var(--accent);\r\n  color: #ffffff;\r\n  border-color: var(--accent);\r\n}\r\n\r\n.page-btn:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n\r\n\r\n\r\n  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\r\n\r\n  body {\r\n    font-family: 'Inter', sans-serif;\r\n    background: #f3f4f6;\r\n    min-height: 100vh;\r\n  }\r\n\r\n  /* ── Background page table ── */\r\n  .page-table-wrap {\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    background: #fff;\r\n  }\r\n\r\n  .page-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    font-size: 13px;\r\n    color: #374151;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .page-table thead th {\r\n    background: #f9fafb;\r\n    padding: 11px 14px;\r\n    text-align: left;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    color: #6b7280;\r\n    border-bottom: 1px solid #e5e7eb;\r\n    border-top: 1px solid #e5e7eb;\r\n  }\r\n\r\n  .page-table tbody td {\r\n    padding: 11px 14px;\r\n    border-bottom: 1px solid #f3f4f6;\r\n    color: #6b7280;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .page-table tbody td.hash { color: #9ca3af; font-weight: 500; }\r\n\r\n  .tbl-btn {\r\n    padding: 4px 12px;\r\n    border-radius: 5px;\r\n    border: 1px solid #d1d5db;\r\n    background: #fff;\r\n    font-size: 12px;\r\n    color: #374151;\r\n    cursor: pointer;\r\n    font-family: 'Inter', sans-serif;\r\n  }\r\n\r\n  .status-pill {\r\n    display: inline-block;\r\n    padding: 3px 10px;\r\n    border-radius: 20px;\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n  }\r\n  .status-success { background: #d1fae5; color: #065f46; }\r\n\r\n  /* ── Overlay ── */\r\n  .overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(107, 114, 128, 0.45);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 100;\r\n    animation: fadeIn 0.15s ease;\r\n  }\r\n\r\n  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\r\n  @keyframes slideUp {\r\n    from { opacity: 0; transform: translateY(12px); }\r\n    to   { opacity: 1; transform: translateY(0); }\r\n  }\r\n\r\n  /* ── Modal ── */\r\n  .modal {\r\n    background: #fff;\r\n    border-radius: 10px;\r\n    width: 870px;\r\n    max-width: 96vw;\r\n    max-height: 90vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 20px 60px rgba(0,0,0,0.18), 0 4px 16px rgba(0,0,0,0.08);\r\n    animation: slideUp 0.2s cubic-bezier(0.16,1,0.3,1);\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .modal-header {\r\n    padding: 20px 24px 0;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: space-between;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .modal-title {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #111827;\r\n  }\r\n\r\n  .modal-sub {\r\n    font-size: 12.5px;\r\n    color: #3b82f6;\r\n    font-weight: 500;\r\n    margin-top: 3px;\r\n    cursor: pointer;\r\n  }\r\n  .modal-sub:hover { text-decoration: underline; }\r\n\r\n  .close-btn {\r\n    width: 28px; height: 28px;\r\n    border: none;\r\n    background: transparent;\r\n    font-size: 20px;\r\n    color: #9ca3af;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 5px;\r\n    transition: background 0.12s;\r\n    flex-shrink: 0;\r\n    font-family: 'Inter', sans-serif;\r\n  }\r\n  .close-btn:hover { background: #f3f4f6; color: #374151; }\r\n\r\n  /* ── Inner table ── */\r\n  .modal-body {\r\n    padding: 16px 24px 24px;\r\n    overflow-x: auto;\r\n    flex: 1;\r\n  }\r\n\r\n  .inner-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    font-size: 13px;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .inner-table thead th {\r\n    padding: 9px 14px;\r\n    text-align: left;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    color: #6b7280;\r\n    border-bottom: 1px solid #e5e7eb;\r\n  }\r\n  .inner-table thead th:first-child { padding-left: 2px; }\r\n\r\n  .inner-table tbody tr:hover { background: #f9fafb; }\r\n  .inner-table tbody tr:not(:last-child) td { border-bottom: 1px solid #f3f4f6; }\r\n\r\n  .inner-table tbody td {\r\n    padding: 13px 14px;\r\n    color: #6b7280;\r\n    font-size: 13px;\r\n  }\r\n  .inner-table tbody td:first-child { padding-left: 2px; }\r\n\r\n  .td-id   { color: #9ca3af; font-size: 12.5px; }\r\n  .td-date { color: #6b7280; font-size: 12.5px; }\r\n  .td-amount { color: #111827; font-weight: 500; }\r\n  .td-method { color: #374151; }\r\n  .td-source { color: #374151; font-weight: 500; }\r\n\r\n  /* Badges */\r\n  .badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    padding: 4px 12px;\r\n    border-radius: 5px;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n  }\r\n  .badge-success { background: #ecfdf5; color: #059669; }\r\n  .badge-failed  { background: #fef2f2; color: #dc2626; }\r\n\r\n  /* Eye button */\r\n  .eye-btn {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: #9ca3af;\r\n    padding: 4px 6px;\r\n    border-radius: 5px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    transition: color 0.12s, background 0.12s;\r\n  }\r\n  .eye-btn:hover { color: #374151; background: #f3f4f6; }\r\n\r\n  /* Version select */\r\n  .version-select {\r\n    appearance: none;\r\n    -webkit-appearance: none;\r\n    background: #fff;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n    color: #6b7280;\r\n    font-family: 'Inter', sans-serif;\r\n    font-size: 12px;\r\n    padding: 6px 28px 6px 10px;\r\n    cursor: pointer;\r\n    outline: none;\r\n    transition: border-color 0.12s;\r\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2.5'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 8px center;\r\n    min-width: 158px;\r\n  }\r\n  .version-select:hover, .version-select:focus { border-color: #93c5fd; }\r\n\r\n\r\n  .modal-dialog-centered {\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n}\r\n\r\n.modal-content {\r\n  border-radius: 10px;\r\n}\r\n\r\n.modal-title{\r\n  font-weight:600;\r\n  font-size:18px;\r\n}\r\n\r\n.modal-sub{\r\n  font-size:13px;\r\n  color:#888;\r\n}\r\n\r\n.inner-table{\r\n  width:100%;\r\n}\r\n\r\n.eye-btn{\r\n  border:none;\r\n  background:transparent;\r\n  cursor:pointer;\r\n}\r\n\r\n.version-select{\r\n  padding:4px 8px;\r\n}\r\n\r\n\r\n.modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 16px 20px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n\r\n  .modal-title {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #374151;\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n.close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  color: #6b7280;\r\n\r\n  &:hover { color: #111; }\r\n}\r\n\r\n.modal-body {\r\n  padding: 16px 20px;\r\n}\r\n\r\n.json-textarea {\r\n  width: 100%;\r\n  height: 320px;\r\n  resize: vertical;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  padding: 12px;\r\n  font-family: monospace;\r\n  font-size: 13px;\r\n  line-height: 1.6;\r\n  color: #1f2937;\r\n  outline: none;\r\n\r\n  &:focus { border-color: #6366f1; }\r\n}\r\n\r\n.modal-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding: 12px 20px;\r\n  border-top: 1px solid #e5e7eb;\r\n\r\n  .submit-btn {\r\n    padding: 8px 24px;\r\n    background: #111827;\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n\r\n    &:hover { background: #374151; }\r\n  }\r\n}\r\n\r\n.submitButton{padding: 8px;}\r\n.filters-row {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n/* shared dropdown/input container */\r\n.control-box {\r\n  position: relative;\r\n  height: 36px;\r\n  min-width: 210px;\r\n  border: 1px solid #d7dbe7;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 12px;\r\n  transition: 0.2s;\r\n}\r\n\r\n/* hover effect */\r\n.control-box:hover {\r\n  border-color: #b8c0d9;\r\n}\r\n\r\n/* focus style */\r\n.control-box:focus-within {\r\n  border-color: #6c8cff;\r\n  box-shadow: 0 0 0 2px rgba(108,140,255,0.15);\r\n}\r\n\r\n/* dropdown */\r\n.control-box select {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  font-size: 14px;\r\n  color: #2d3553;\r\n  appearance: none;\r\n}\r\n\r\n/* input */\r\n.control-box input {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  font-size: 14px;\r\n  color: #2d3553;\r\n}\r\n\r\n/* icons */\r\n.control-box .icon {\r\n  margin-right: 8px;\r\n  color: #7b819c;\r\n  font-size: 14px;\r\n}\r\n\r\n.control-box .arrow {\r\n  position: absolute;\r\n  right: 10px;\r\n  font-size: 12px;\r\n  color: #7b819c;\r\n  pointer-events: none;\r\n}\r\n.resubmitButton{border: 1px solid gray;\r\n    padding: 6px;}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
